import * as React from 'react';

export type SelectedClientsOrLocationsProps = {
    title: string;
    items: ReadonlyArray<Record<'id' | 'title', string>>;
};

export const SelectedClientsOrLocations: React.FunctionComponent<SelectedClientsOrLocationsProps> = ({
    items,
    title,
}) => (
    <>
        <div className="branded-alternate">
            <h3 style={{ fontSize: 18 }}>{`${title} (${items.length})`}</h3>
        </div>
        <ul style={{ listStyleType: 'disc' }}>
            {items.map(item => (
                <li key={item.id}>{item.title}</li>
            ))}
        </ul>
    </>
);
SelectedClientsOrLocations.displayName = 'SelectedClientsOrLocations';
